import moment from "moment";
import api from "../../../../api";
import map from "../../../map";
import environment from "../../../../environment";

export const storeExportType = {
    NetworkAfterSales: 1,
    CompetitorsAfterSales: 2,
};

export const storeExportTypeName = {
    NetworkAfterSales: 'Camada Rede',
    CompetitorsAfterSales: 'Camada Concorrentes',
};

export const storeExportTypeNames = Object.keys(storeExportTypeName).reduce((acc, curr) => {
    acc[storeExportType[curr]] = storeExportTypeName[curr];
    return acc;
}, {});

export const exportStore = (storeExportType) => {
    const payload = {
        filename: `${environment.get('CONFIG.CLIENT')}_Lojas ${storeExportTypeNames[storeExportType]}_v${moment().format('YYYYMMDD')}.xlsx`,
        bbox: map.getCurrentBbox(),
        type: storeExportType,
    };

    return api.afterSales.get.stores.export(payload);
};



// WEBPACK FOOTER //
// ./src/scripts/core/export/afterSales/stores/index.js